import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainComponent } from './main/main.component';
import { SharedModule } from '../shared/shared.module';
import { NavbarModule } from './navbar/navbar.module';

@NgModule({
  declarations: [MainComponent],
  imports: [NavbarModule, CommonModule, SharedModule],
})
export class LayoutModule {}
